var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg433(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 130,
    viewBox: "0 0 100 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "field-marks",
    strokeWidth: 0.25,
    stroke: "#909da8",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    x2: 50,
    y2: 65
  }), /*#__PURE__*/React.createElement("rect", {
    y: 22.5,
    width: 6,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 22.5,
    width: 6,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.5,
    width: 18,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 10.5,
    width: 18,
    height: 44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 32.5,
    r: 0.667,
    fill: "#909da8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 32.5,
    r: 0.667,
    fill: "#909da8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18 24.5 A 10 10 0 0 1 18 40.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82 24.5 A 10 10 0 0 0 82 40.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 32.5,
    r: 0.667,
    fill: "#909da8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 32.5,
    r: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "players",
    fill: "none",
    strokeWidth: 0.75,
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 32.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 10,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 24,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 41,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 55,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 22.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 32.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 42.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 12,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 32.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 53,
    r: 2.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg433);
export default __webpack_public_path__ + "static/media/4-3-3.173af3ff3f689ff79ff85063ed61f366.svg";
export { ForwardRef as ReactComponent };